var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('AdditiveItemComponent',{attrs:{"operationType":_vm.operationType},on:{"close":function($event){_vm.handleDataCloseOperacije($event)}}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }